// SplashPage.jsx
import React from 'react';        
import splashBg from '../assets/splash-bg.jpg';

export default function SplashPage({ searchOpen }) {
  // Tweak these two only
  const titleSize = 'clamp(48px, 4vw, 120px)';
  const subtitleSize = 'clamp(48px, 4vw, 120px)';

  const titleStyle = {
    fontFamily: "'Thesignature', 'Barlow Semi Condensed', system-ui, sans-serif",
    fontSize: titleSize,
    lineHeight: 1.1,
    letterSpacing: 0.5,
    margin: 0
  };

  const subtitleStyle = {
    fontFamily: "'Georgia', 'Times New Roman', system-ui, sans-serif",
    fontSize: subtitleSize,
    lineHeight: 1.2,
    letterSpacing: 0.25,
    margin: 0
  };

  const sectionStyle = {
    backgroundImage: `url(${splashBg})`
  };

  return (
    <section className="splash" style={sectionStyle}>
      <div className="banner">
        <div className="marquee">
          {/* Keep your existing banner text logic */}
          <span>
            Welcome to the official Voice of Virtues website! This year’s conference will be held on November 8th, 2025 at ICBCS. Follow us on Instagram (@voices.of.virtue) for more updates!
          </span>
          <span>
            Welcome to the official Voice of Virtues website! This year’s conference will be held on November 8th, 2025 at ICBCS. Follow us on Instagram (@voices.of.virtue) for more updates!
          </span>
        </div>
      </div>

      {searchOpen && (
        <div className="search-bar">
          <input type="text" placeholder="Search..." />
        </div>
      )}

      <div className="splash-center">
        <h1 className="splash-title" style={titleStyle}>Texas Islamic Conference</h1>
        <h2 className="splash-subtitle" style={subtitleStyle}>VOICES OF VIRTUE</h2>
      </div>
    </section>
  );
}